import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectClient } from '@api/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LoadingService } from '@shared/services/loading.service';
import { catchError, exhaustMap, map, of, switchMap, tap } from 'rxjs';
import { OfferActions } from '../offer-store/offer.actions';
import { ProjectsActions } from './projects.actions';
import { selectSelectedProjectId } from './projects.selector';

@Injectable()
export class ProjectsEffects {
  projects$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProjectsActions.loadProjects),
      switchMap(() =>
        this.projectClient.getAll().pipe(
          map(projects => ProjectsActions.projectsLoaded({ projects })),
          catchError(error => of(ProjectsActions.loadProjectsFailed({ error })))
        )
      )
    );
  });

  refreshProject$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        ProjectsActions.projectAccepted,
        ProjectsActions.projectDetailsPageOpened,
        ProjectsActions.refreshProject,
        OfferActions.finalMeasurmentSaved,
        OfferActions.offerSaved,
        OfferActions.offerFinalized,
        OfferActions.finalMeasurmentFinalized
      ),
      tap(() => this.loadingService.showSpinner()),
      switchMap(() => this.store.select(selectSelectedProjectId)),
      exhaustMap((id: string | null) => {
        if (!id) {
          this.router.navigate(['/projects']);
          return of(ProjectsActions.loadProjectFailed({ error: 'No project id set' }));
        }

        return this.projectClient.get(id).pipe(
          map(project => ProjectsActions.projectLoaded({ project })),
          catchError(error => of(ProjectsActions.loadProjectFailed({ error })))
        );
      }),
      tap(() => this.loadingService.hideSpinner())
    );
  });

  constructor(
    private actions$: Actions,
    private loadingService: LoadingService,
    private projectClient: ProjectClient,
    private router: Router,
    private store: Store
  ) {}
}
